import React, { useState } from "react";
import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";

import ManualSubscriptionForm from "./form";
import { useManualSubscription } from "@/api/hooks/useManualSubscription";

import DashboardContent from "@/components/app/DashboardContent";
import DashboardHeader from "@/components/app/DashboardHeader";
import ROUTE_CONSTANTS from "@/constants/route-constants";
import { getAxiosError } from "@/utils/get-axios-error";

const ManualSubscriptionWrapper: React.FC = () => {
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const manualSubscription = useManualSubscription();

    const handleSubmit = async (values: any, resetForm?: () => void) => {
        setSubmitLoading(true);
        manualSubscription.mutate(
            {
                userId: Number(values.userId),
                planId: Number(values.planId),
                startFrom: new Date(values.startFrom).toISOString(),
            },
            {
                onSuccess: () => {
                    enqueueSnackbar("Subscription created successfully!", { variant: "success" });
                    if (resetForm) resetForm();
                },
                // onError: (err: any) => {
                //   const error = getAxiosError(err);
                //   const message = error?.meta.message || "Server Error";
                //   enqueueSnackbar(message, { variant: "error" });
                // },
                onSettled: () => {
                    setSubmitLoading(false);
                },
            }
        );
    };

    return (
        <>
            <DashboardHeader
                title="Manual Subscription"
                titleSuffix={
                    <Button component="a" href={ROUTE_CONSTANTS.DASHBOARD.ROOT.ABSOLUTE}>
                        Back To Dashboard
                    </Button>
                }
            />
            <DashboardContent>
                <ManualSubscriptionForm loading={submitLoading} onSubmit={(values, reset) => handleSubmit(values, reset)} />
            </DashboardContent>
        </>
    );
};

export default ManualSubscriptionWrapper;
